import {useCallback, useEffect} from 'react';
import {ApiStatusCodeVo} from '../../../../../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {commonErrorHandler} from '../../../../../../errors/commonErrorHandler';
import {getSerializedPagewebError} from '../../../../../../errors/getSerializedPagewebError.function';
import {PagewebError} from '../../../../../../errors/PagewebError.class';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';

export function useFetchViewerInfo({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}) {
  // React Query로 데이터 페칭
  const result = useViewerInfoQuery({seriesId, productId});

  const {data, isLoading, refetch, error} = result;

  // 특별한 에러 처리 (VodDeviceLimitOver)
  useEffect(() => {
    if (error) {
      const pagewebError = error as PagewebError;
      // @ts-expect-error - PagewebError에 resultCode 속성이 있음
      if (pagewebError.resultCode === ApiStatusCodeVo.VodDeviceLimitOver) {
        // 기기 등록을 처리합니다
        const serializedError = getSerializedPagewebError(pagewebError);
        commonErrorHandler(serializedError);
      } else {
        throw new PagewebError(pagewebError);
      }
    }
  }, [error]);

  const handleRefetch = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    isLoading,
    data,
    refetch: handleRefetch,
  };
}
